import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ApplicationForResidency from './application-for-residency.vue';
import { trackYaGoal } from '@/js/utils/yandex-metrika';

const MOUNT_ID = 'application-for-residency-vue';

interface ResidencyOpenParams {
  cluster?: string;
}

let residencyApp: App<Element> | null = null;

let residencyInstance: {
  open: (params?: ResidencyOpenParams) => void;
} | null = null;

let currentMountEl: HTMLElement | null = null;

let residencyTriggersInitialized = false;

function resolveMountRoot(root?: ParentNode): HTMLElement | null {
  const fromDom = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (fromDom) {
    return fromDom;
  }

  const dynamicMountEl = document.createElement('div');

  dynamicMountEl.id = MOUNT_ID;

  document.body.appendChild(dynamicMountEl);

  return dynamicMountEl;
}

function mountResidencyModal(root?: ParentNode): void {
  const mountEl = resolveMountRoot(root);

  if (!mountEl) {
    return;
  }

  if (residencyApp && currentMountEl) {
    residencyApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ApplicationForResidency);

  app.use(AntDesignVue);

  const instance = app.mount(mountEl) as unknown as {
    open: (params?: ResidencyOpenParams) => void;
  };

  residencyApp = app;
  residencyInstance = instance;
  currentMountEl = mountEl;
}

export function openApplicationForResidency(params?: ResidencyOpenParams): void {
  if (!residencyApp || !residencyInstance) {
    mountResidencyModal();
  }

  residencyInstance?.open(params);
}

export function initApplicationForResidencyTriggers(): void {
  if (residencyTriggersInitialized) {
    return;
  }

  residencyTriggersInitialized = true;

  mountResidencyModal();

  document.addEventListener('click', (event: Event) => {
    const target = event.target as HTMLElement | null;

    const trigger = target?.closest<HTMLElement>('[data-residency-open-modal]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    trackYaGoal('becomeResident');

    openApplicationForResidency({
      cluster: trigger.dataset.cluster,
    });
  });
}
